export default "__VITE_ASSET__gCKEbtID__"